import classNames from "classnames";
import { useAtomValue } from "jotai";
import { Trans } from "react-i18next";
import { themeAtom } from "@src/jotai/theme";
import { VIDEO_REMAKE_CARDS } from "./config";

interface WelcomeVideoRemakeCardProps {
  onGo2VideoRemake: () => void;
}

export function WelcomeVideoRemake(props: WelcomeVideoRemakeCardProps) {
  const { onGo2VideoRemake } = props;
  const isDark = useAtomValue(themeAtom) === "dark";

  return (
    <div className="min-h-full bg-kds-bg-soft flex flex-col items-center pt-[200px]">
      <div className="w-[800px] flex flex-col items-center gap-[40px]">
        <h1
          className={classNames(
            "text-[32px] leading-[1.4] font-bold m-0",
            isDark ? "kalo-text-linear-gray" : "text-kds-fg",
          )}
        >
          <Trans>Video Transform</Trans>
        </h1>

        <div className="flex items-center gap-[20px]">
          {VIDEO_REMAKE_CARDS.map((card) => (
            <div
              key={card.key}
              onClick={
                card.disabled
                  ? undefined
                  : () => {
                      if (card.key === "video-remake") {
                        onGo2VideoRemake();
                      }
                    }
              }
              className={classNames(
                "w-[253px] h-[327px] rounded-[12px] p-px shadow-[0px_4px_24px_0px_var(--kds-shadow-soft)] transition-colors",
                "text-left overflow-hidden",
                card.disabled
                  ? "bg-kds-border-solid opacity-40 cursor-not-allowed"
                  : "bg-kds-bg cursor-pointer hover:bg-[linear-gradient(to_bottom_right,var(--kds-accent)_0%,var(--kds-chart-violet)_55%,transparent_100%)]",
              )}
            >
              <div
                className={classNames(
                  "size-full rounded-[11px] p-[15px] flex flex-col items-center justify-center gap-[16px]",
                  card.disabled ? "bg-kds-bg-subtle" : "bg-kds-bg",
                )}
              >
                <div className="size-[64px] rounded-full bg-kds-bg-subtle flex items-center justify-center shrink-0 text-kds-fg">
                  {card.renderIcon("size-[28px]")}
                </div>

                <div className="w-full flex flex-col items-center gap-[8px] select-none">
                  <div className="text-[16px] leading-[1.4] font-bold text-kds-fg text-center whitespace-nowrap">
                    <Trans>{card.title}</Trans>
                  </div>
                  <div className="w-full text-[14px] leading-[1.4] font-normal text-kds-fg-soft">
                    <Trans>{card.description}</Trans>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
